import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formatDate, useEffectOnce, usePathParam } from '@chilecompra/react-kit'
import { Card, Typography } from '@chilecompra/react-kit/components'
import { useAuthorization } from '../AuthorizationProvider/AuthorizationProvider.hooks'
import {
  onFrameworkAgreementDocumentsThunk,
  onFrameworkDownloadDocumentThunk
} from './FrameworksAgreementSection.actions'
import {
  ContentWrapper,
  DocumentBox,
  DocumentFile,
  DocumentFileLoading,
  Subtitle,
  Title
} from './FrameworksAgreementSection.styles'

/**
 * The FrameworksAgreementSection's container.
 */
const FrameworksAgreementSection = () => {
  const dispatch = useDispatch()
  const dni = usePathParam('rut')
  const { userType } = useAuthorization()
  const { contractStatus, loading: contractStatusLoading } = useSelector(state => state.basicSellerInformation)
  const { downloads, frameworkAgreements } = useSelector(state => state.frameworkAgreementSection)

  const handleDocumentDownload = (identifier, filename) => () =>
    dispatch(onFrameworkDownloadDocumentThunk({ filename, id: identifier }))

  useEffectOnce(() => {
    dispatch(onFrameworkAgreementDocumentsThunk({ dni, userType }))
  })

  if (contractStatusLoading) return null
  if (contractStatus !== 1) return null

  return frameworkAgreements?.map((frameworkAgreement, i) => (
    <Card color="blank" enableBorder key={'bigBox' + i} margin="10px 0 0" padding="32px 24px 8px">
      <ContentWrapper alignSelf="center" flexDirection="row" width="100%">
        <ContentWrapper alignSelf="center" flexDirection="column" width="50%">
          <ContentWrapper justifyContent="space-between">
            <Title>Documentos Convenio Marco {frameworkAgreement.name}</Title>
          </ContentWrapper>
          <ContentWrapper justifyContent="space-between">
            <Subtitle>
              Estos son los documentos que presentó el proveedor al momento de adjudicar en este convenio
            </Subtitle>
          </ContentWrapper>
        </ContentWrapper>
        <ContentWrapper alignSelf="center" flexDirection="column" maringleft="45px" width="100%">
          {frameworkAgreement.documents.map((document, index) => {
            return (
              <DocumentBox key={'documentBox' + index}>
                <ContentWrapper alignSelf="center" flexDirection="column" padding="0 28px 0 23px">
                  {downloads.some(id => id === document.documentId) && (
                    <DocumentFileLoading>Descargando...</DocumentFileLoading>
                  )}
                  {!downloads.some(id => id === document.documentId) && (
                    <DocumentFile
                      onClick={handleDocumentDownload(
                        document.documentId,
                        `${document.documentType}.${document.documentExtension}`
                      )}
                      target="_blank"
                    >
                      {document.documentType}
                    </DocumentFile>
                  )}
                </ContentWrapper>
                <ContentWrapper alignSelf="center" flexDirection="column" padding="0 28px 0 23px">
                  <ContentWrapper justifyContent="space-between">
                    <Typography fontSize="13px" variant="subtitle">
                      Fecha de carga: {formatDate(document.receptionDate, 'dd-MM-yyyy')}
                    </Typography>
                  </ContentWrapper>
                </ContentWrapper>
              </DocumentBox>
            )
          })}
        </ContentWrapper>
      </ContentWrapper>
    </Card>
  ))
}

export default FrameworksAgreementSection
